import InfoPage, { handle } from '@modules/professional/page/InfoPage';
import { loader } from '@modules/professional/api/info-page-loader.server';
export { loader, handle };
export default InfoPage;
